import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import { ADMIN_DMS_READ, ADMIN_DMS_WRITE } from 'constants/rightsCodes';
import ContentTypesListBrowser from './ContentTypesListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_DMS_WRITE} withForbiddenPage={false}>
          <IconButton
            onClick={() => historyContext.push(`/contentTypes/new`)}
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Tooltips.ContentTypes.Add')}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DMS_READ}>
        <ContentTypesListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
